import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { SelectionGroup, SelectionGroupItem, Typography, Adaptive } from 'fronton-react';
import { Drop, DropCrossedOut, DropSmall, DropCrossedOutSmall } from 'assets';
import { forWetRoomsLabels } from '../../const';
import { HeaderContainer, SelectionGroupClassname, SelectionGroupContent } from './styles';
import { ForWetRoomsType, ParametersEnum, TGetIcon } from '../../types';
import { getNextValueSingleChoice } from '../../helpers/get-selection-group-next-value';

const forWetRoomsParams = [
  {
    name: ForWetRoomsType.YES,
    label: forWetRoomsLabels.YES,
    getIcon: ({ isSmall }: TGetIcon) => (isSmall ? <DropSmall /> : <Drop />),
  },
  {
    name: ForWetRoomsType.NO,
    label: forWetRoomsLabels.NO,
    getIcon: ({ isSmall }: TGetIcon) => (isSmall ? <DropCrossedOutSmall /> : <DropCrossedOut />),
  },
];

export const ForWetRoomsParams = () => {
  const { control, setValue } = useFormContext();

  return (
    <div>
      <HeaderContainer>
        <Adaptive to="tablet">
          <Typography variant="m" color="text-primary" size="subtitle">
            Для влажных помещений
          </Typography>
        </Adaptive>
        <Adaptive from="tablet">
          <Typography variant="l" color="text-primary" size="body_accent">
            Для влажных помещений
          </Typography>
        </Adaptive>
      </HeaderContainer>
      <Controller
        name={ParametersEnum.forWetRooms}
        control={control}
        render={({ field: { onChange, value } }) => (
          <SelectionGroup
            active={value}
            onChange={(_, forWetRoomsValue) => {
              onChange();
              setValue(
                ParametersEnum.forWetRooms,
                getNextValueSingleChoice({ clickedValue: forWetRoomsValue, currentValue: value })
              );
            }}
            variant="composite"
            size="l"
            className={SelectionGroupClassname}>
            {forWetRoomsParams.map(forWetRoomsItem => (
              <SelectionGroupItem
                key={forWetRoomsItem.name}
                value={forWetRoomsItem.name}
                data-testid={`${forWetRoomsItem.name}-for-wet-rooms-select`}>
                <SelectionGroupContent>
                  <Adaptive to="tablet">{forWetRoomsItem.getIcon({ isSmall: true })}</Adaptive>
                  <Adaptive from="tablet">{forWetRoomsItem.getIcon({ isSmall: false })}</Adaptive>
                  <Typography variant="m" size="body_accent" color="text-primary">
                    {forWetRoomsItem.label}
                  </Typography>
                </SelectionGroupContent>
              </SelectionGroupItem>
            ))}
          </SelectionGroup>
        )}
      />
    </div>
  );
};
